/**
 * @description
 * Lets features observe failed API requests (5xx, network errors) without
 * the global ResponseProcessor depending on them.
 * status is 0 when no response was received (network error, CORS, timeout).
 */
export type RequestErrorInfo = {
  status: number;
  method: string;
  url: string;
};

type Listener = (info: RequestErrorInfo) => void;

const listeners = new Set<Listener>();

export function onRequestError(listener: Listener): () => void {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

export function notifyRequestError(info: RequestErrorInfo) {
  listeners.forEach((listener) => {
    try {
      listener(info);
    } catch (e) {
      console.error(e);
    }
  });
}
